<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer005">
<p class="Text-body-after-subhead ParaOverride-3"><span class="Text-body CharOverride-5">Contents</span></p>
<p> </p>
<p> </p>
<p class="TOC-2"><span class="Text-body CharOverride-6"><a href="#/Text/acknowledgments">Acknowledgments</a></span></p>
<p class="TOC-2"><span class="Text-body CharOverride-6"><a href="#/Text/acknowledgments">Preface to the Second Edition</a></span></p>
<p class="TOC-2"><span class="Text-body CharOverride-6"><a href="#/Text/introduction">Introduction</a></span></p>
<p class="TOC-1"><span class="Text-body CharOverride-7"><a href="#/Text/part1">Part I: Class Struggle in the Land of Opportunity, 1865–1930</a></span></p>
<p class="TOC-2"><span class="Text-body CharOverride-6"><a href="#/Text/chapter1">1.	Are American Workers Different?</a></span></p>
<p class="TOC-2"><span class="Text-body CharOverride-6"><a href="#/Text/chapter2">2.	The Peculiarities of American Capitalism	</a></span></p>
<p class="TOC-1"><span class="Text-body CharOverride-7"><span href="#/Text/part2" title="Link target outside of Sample">Part II: The Battle for Industrial Unions—The View from Below</span></span></p>
<p class="TOC-2"><span class="Text-body CharOverride-6"><span href="#/Text/chapter3" title="Link target outside of Sample">3.	The Rise of the Labor Left, 1900–1930	</span></span></p>
<p class="TOC-2"><span class="Text-body CharOverride-6"><span href="#/Text/chapter4" title="Link target outside of Sample">4.	Depression Decade: The Turning Point	</span></span></p>
<p class="TOC-1"><span class="Text-body CharOverride-7"><span href="#/Text/part3" title="Link target outside of Sample">Part III: The Employers Strike Back</span></span></p>
<p class="TOC-2"><span class="Text-body CharOverride-6"><span href="#/Text/chapter5" title="Link target outside of Sample">5.	From World War to Cold War	</span></span></p>
<p class="TOC-2"><span class="Text-body CharOverride-6"><span href="#/Text/chapter6" title="Link target outside of Sample">6.	Social Contract?</span></span></p>
<p class="TOC-1"><span class="Text-body CharOverride-7"><span href="#/Text/part4" title="Link target outside of Sample">Part IV: One-Sided Class War</span> </span></p>
<p class="TOC-2"><span class="Text-body CharOverride-6"><span href="#/Text/chapter7" title="Link target outside of Sample">7.	The Employers’ Offensive	</span></span></p>
<p class="TOC-2"><span class="Text-body CharOverride-6"><span href="#/Text/chapter8" title="Link target outside of Sample">8.	The Neoliberal President Dismantles the New Deal	</span></span></p>
<p class="TOC-2"><span class="Text-body CharOverride-6"><span href="#/Text/chapter9" title="Link target outside of Sample">9.	Rule of the Neocons	</span></span></p>
<p class="TOC-1"><span class="Text-body CharOverride-7"><span href="#/Text/part5" title="Link target outside of Sample">	Part V: From George W. Bush to Donald J. Trump</span></span></p>
<p class="TOC-2"><span class="Text-body CharOverride-6"><span href="#/Text/chapter10" title="Link target outside of Sample">10.	Manufactured on Wall Street: The Great Recession</span></span></p>
<p class="TOC-2"><span class="Text-body CharOverride-6"><span href="#/Text/chapter11" title="Link target outside of Sample">11.	The Flashpoints of a New Resistance	</span></span></p>
<p class="TOC-2"><span class="Text-body CharOverride-6"><span href="#/Text/chapter12" title="Link target outside of Sample">12. 	The Rogue President	</span></span></p>
<p> </p>
<p class="TOC-2"><span class="Text-body CharOverride-6"><span href="#/Text/notes" title="Link target outside of Sample">Notes</span></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?8fa96aaa